import { useToast } from "@chakra-ui/react"
import { config } from "lib/helpers/config"
import { useAuth } from "lib/providers/AuthProvider"
import { useCallback } from "react"

export const useReportDownload = (ratingId: string) => {
  const { token } = useAuth()
  const toast = useToast()

  const download = useCallback(
    async (pdfReportKey?: string) => {
      const params = new URLSearchParams({ ratingId, authToken: token })
      if (pdfReportKey) {
        params.set("pdfReportKey", pdfReportKey)
      }

      const url = `${config.API_URL}/download-report?${params.toString()}`

      if (!url.startsWith(config.API_URL)) {
        toast({
          title: "Feil ved nedlasting",
          description: "Det skjedde en feil ved nedlastingningen",
          status: "error",
          position: "top",
          isClosable: true,
        })
        return
      }

      window.location.href = url
    },
    [ratingId, token, toast],
  )

  return download
}
